import Icon from '../Icon';
import type { LucideIconData, LucideIconNode, LucideProps } from '../types';

export const __iconData: LucideIconData = {
  name: 'message-square-dashed',
  size: 24,
  node: [
    ['path', { d: 'M14 3h2', key: '1d12a5' }],
    ['path', { d: 'M16 19h-2', key: '1agirb' }],
    ['path', { d: 'M2 12v-2', key: '1ey295' }],
    ['path', { d: 'M2 16v5.286a.71.71 0 0 0 1.212.502l1.149-1.149', key: '120k8q' }],
    ['path', { d: 'M20 19a2 2 0 0 0 2-2v-1', key: 'ior8tn' }],
    ['path', { d: 'M22 10v2', key: 'rmlecy' }],
    ['path', { d: 'M22 6V5a2 2 0 0 0-2-2', key: 'sp3k6r' }],
    ['path', { d: 'M4 3a2 2 0 0 0-2 2v1', key: '11zt7s' }],
    ['path', { d: 'M8 19h2', key: 'jnunrx' }],
    ['path', { d: 'M8 3h2', key: 'ysbsee' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name MessageSquareDashed
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgM2gyIiAvPgogIDxwYXRoIGQ9Ik0xNiAxOWgtMiIgLz4KICA8cGF0aCBkPSJNMiAxMnYtMiIgLz4KICA8cGF0aCBkPSJNMiAxNnY1LjI4NmEuNzEuNzEgMCAwIDAgMS4yMTIuNTAybDEuMTQ5LTEuMTQ5IiAvPgogIDxwYXRoIGQ9Ik0yMCAxOWEyIDIgMCAwIDAgMi0ydi0xIiAvPgogIDxwYXRoIGQ9Ik0yMiAxMHYyIiAvPgogIDxwYXRoIGQ9Ik0yMiA2VjVhMiAyIDAgMCAwLTItMiIgLz4KICA8cGF0aCBkPSJNNCAzYTIgMiAwIDAgMC0yIDJ2MSIgLz4KICA8cGF0aCBkPSJNOCAxOWgyIiAvPgogIDxwYXRoIGQ9Ik04IDNoMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/message-square-dashed
 * @see https://lucide.dev/guide/packages/lucide-solid - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MessageSquareDashed = (props: LucideProps) => <Icon {...props} icon={__iconData} />;

export default MessageSquareDashed;
